import { OrbitControls } from '@react-three/drei';
import { useThree } from '@react-three/fiber';
import { useEffect } from 'react';
import * as THREE from 'three';

import { CAMERA_POSITION } from '../constants';

export default function DebugCamera() {
  const { camera } = useThree();

  useEffect(() => {
    const initialPosition = CAMERA_POSITION.clone();
    const initialRotation = new THREE.Euler(0, 0, 0);
    const initialZoom = camera.zoom;

    return () => {
      // Reset to initial state when unmounting
      camera.position.copy(initialPosition);
      camera.rotation.copy(initialRotation);
      camera.zoom = initialZoom;
      camera.updateProjectionMatrix();
    };
  }, [camera]);

  return <OrbitControls makeDefault target={[0, CAMERA_POSITION.y, 1]} />;
}
